import { render, staticRenderFns } from "./BrokerLeadView.vue?vue&type=template&id=3da4e348"
import script from "./BrokerLeadView.vue?vue&type=script&lang=js"
export * from "./BrokerLeadView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports